function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M478.751,0.139H367.848H256.945H146.043H35.139c-0.56,0-1.119-0.219-1.67-0.108c-0.266,0.052-0.51,0.013-0.766,0.087 c-0.276,0.083-0.555,0.077-0.824,0.187c-0.313,0.129-0.6,0.271-0.893,0.435c-0.191,0.106-0.389,0.171-0.573,0.294 c-0.94,0.627-1.747,1.425-2.374,2.366c-0.121,0.181-0.201,0.373-0.306,0.56c-0.167,0.296-0.344,0.583-0.475,0.898 c-0.11,0.269-0.173,0.548-0.255,0.823c-0.076,0.256-0.647,0.502-0.7,0.767c-0.109,0.552-0.64,1.11-0.64,1.668v110.903v110.903 v76.779v34.124V512h17.062V349.911h103.318h110.902h110.903h110.903c4.711,0,7.586-4.37,7.586-9.085V229.923V119.019V8.116 C486.337,3.401,483.462,0.139,478.751,0.139z M42.725,28.711l82.722,82.332h-35.59L42.725,64.301V28.711z M42.725,88.428 l23.005,22.615H42.725V88.428z M42.725,332.849v-22.615l23.005,22.615H42.725z M89.857,332.849l-47.132-46.741v-35.59 l82.722,82.332H89.857z M136.566,320.231l-80.833-81.224h35.59l45.243,45.633V320.231z M136.566,260.514l-21.116-21.507h21.116 V260.514z M136.566,221.946H42.725v-93.841h93.841V221.946z M136.566,98.425L55.733,17.201h35.59l45.243,45.633V98.425z  M136.566,38.708L115.45,17.201h21.116V38.708z M153.628,139.614l82.722,82.332h-35.59l-47.132-46.741V139.614z M153.628,199.331 l23.005,22.615h-23.005V199.331z M247.469,332.849h-93.841v-93.841h93.841V332.849z M247.469,209.328l-80.833-81.224h35.59 l45.243,45.633V209.328z M247.469,149.611l-21.116-21.507h21.116V149.611z M247.469,111.043h-93.841V17.201h93.841V111.043z  M264.531,28.711l82.722,82.332h-35.59l-47.132-46.741V28.711z M264.531,88.428l23.005,22.615h-23.005V88.428z M264.531,332.849 v-22.615l23.005,22.615H264.531z M311.663,332.849l-47.132-46.741v-35.59l82.722,82.332H311.663z M358.372,320.231l-80.833-81.224 h35.59l45.243,45.633V320.231z M358.372,260.514l-21.116-21.507h21.116V260.514z M358.372,221.946h-93.841v-93.841h93.841V221.946 z M358.372,98.425l-80.833-81.224h35.59l45.243,45.633V98.425z M358.372,38.708l-21.116-21.507h21.116V38.708z M375.434,139.614 l82.722,82.332h-35.59l-47.132-46.741V139.614z M375.434,199.331l23.005,22.615h-23.005V199.331z M469.275,332.849h-93.841 v-93.841h93.841V332.849z M469.275,209.328l-80.833-81.224h35.59l45.243,45.633V209.328z M469.275,149.611l-21.116-21.507h21.116 V149.611z M469.275,111.043h-93.841V17.201h93.841V111.043z"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", null);

var _ref4 =
/*#__PURE__*/
React.createElement("g", null);

var _ref5 =
/*#__PURE__*/
React.createElement("g", null);

var _ref6 =
/*#__PURE__*/
React.createElement("g", null);

var _ref7 =
/*#__PURE__*/
React.createElement("g", null);

var _ref8 =
/*#__PURE__*/
React.createElement("g", null);

var _ref9 =
/*#__PURE__*/
React.createElement("g", null);

var _ref10 =
/*#__PURE__*/
React.createElement("g", null);

var _ref11 =
/*#__PURE__*/
React.createElement("g", null);

var _ref12 =
/*#__PURE__*/
React.createElement("g", null);

var _ref13 =
/*#__PURE__*/
React.createElement("g", null);

var _ref14 =
/*#__PURE__*/
React.createElement("g", null);

var _ref15 =
/*#__PURE__*/
React.createElement("g", null);

var _ref16 =
/*#__PURE__*/
React.createElement("g", null);

var _ref17 =
/*#__PURE__*/
React.createElement("g", null);

var SvgFlagIcon = function SvgFlagIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgFlagIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/flag-icon.8d429a20.svg";
export { ForwardRef as ReactComponent };